module.exports = __webpack_public_path__ + "img/barring_pin_protection.0dabbb75.svg";